export default __webpack_public_path__ + "static/media/logo-google.e835cd7c.svg";